import React from 'react';
import { useForm } from 'react-hook-form';

import Field from 'components/Field';
import Button from 'components/Button';

const NewPassword = ({onSubmit}) => {
  const { handleSubmit, register, formState: { errors } } = useForm();
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Field label="Nouveau mot de passe" type="password"
      register={
        register("password", {
          required: true,
        })
      }/>
      <Field label="Confirmer le nouveau mot de passe" type="password"
      register={
        register("password_confirmation", {
          required: true,
        })
      }/>
      <Button type="submit" className="is-primary">
        Changer de mot de passe
      </Button>
    </form>
  );
}

export default NewPassword;